import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { VersionCheckService } from "./modules/shared/service/version-check/version-check.service";

@Component({
  selector: "app-my-app",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  private _router!: Subscription;
  private _updateSub?: Subscription;

  constructor(
    private readonly router: Router,
    private readonly versionCheckService: VersionCheckService,
    private readonly snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this._router = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event) => {
        const body = document.getElementsByTagName("body")[0];
        const modalBackdrop = document.getElementsByClassName(
          "modal-backdrop",
        )[0] as HTMLElement | undefined;
        if (body && body.classList && body.classList.contains("modal-open")) {
          body.classList.remove("modal-open");
          if (
            modalBackdrop &&
            typeof (modalBackdrop as any).remove === "function"
          ) {
            (modalBackdrop as any).remove();
          }
        }
      });

    this.versionCheckService.startPolling();
    this._updateSub = this.versionCheckService.updateAvailable$.subscribe(() => {
      this.showUpdateNotification();
    });
  }

  ngOnDestroy(): void {
    this._router?.unsubscribe();
    this._updateSub?.unsubscribe();
  }

  /**
   * Muestra un snackbar persistente (no se auto-cierra) indicando que hay una
   * nueva versión disponible. Al presionar "Actualizar", recarga la página.
   */
  private showUpdateNotification(): void {
    const snackBarRef = this.snackBar.open(
      "Nueva versión disponible",
      "Actualizar",
      { panelClass: ["snackbar-update"] }
    );

    snackBarRef.onAction().subscribe(() => {
      this.versionCheckService.reloadApp();
    });
  }
}
